import React, { useState } from "react";
import { motion } from "framer-motion";
import { Zap } from "lucide-react";
import { Link } from "react-router-dom";
import styles from "./contactPage.module.css";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    research: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch("https://formspree.io/f/xrerwwnw", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setSubmitted(true);
    }
  };
  return (
    <div className={styles.page}>
      <div className={styles.background}>
        <div className={styles.glowPrimary} />
        <div className={styles.glowAccent} />
      </div>

      <div className={styles.container}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className={styles.card}
        >
          {!submitted ? (
            <>
              <div className={styles.header}>
                <div className={styles.badge}>
                  <Zap className={styles.badgeIcon} />
                  <span className={styles.badgeText}>Early Access</span>
                </div>
                <h1 className={styles.title}>Join the Beta</h1>
                <p className={styles.subtitle}>
                  Tell us about yourself and your research, we will be in touch
                  shortly with access details.
                </p>
              </div>
              <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.field}>
                  <label className={styles.label}>Full Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your name"
                    className={styles.input}
                    required
                  />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>Company / Insitution</label>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Organization name"
                    className={styles.input}
                    required
                  />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="your@email.com"
                    className={styles.input}
                    required
                  />
                </div>

                <div className={styles.field}>
                  <label className={styles.label}>
                    What are you working on?
                  </label>
                  <textarea
                    name="research"
                    value={formData.research}
                    onChange={handleChange}
                    placeholder="Have a Mitochondrial Paradox? Describe it here"
                    className={styles.textarea}
                    rows={4}
                    required
                  />
                </div>

                <button type="submit" className={styles.button}>
                  Request Access
                </button>
              </form>
            </>
          ) : (
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4 }}
              className={styles.success}
            >
              {/* <div className={styles.successIcon}>⚡</div>*/}
              <h2 className={styles.successTitle}>Congratulations!</h2>
              <h2 className={styles.successTitle}>
                You have been added to the list
              </h2>
              <p className={styles.successText}>
                Thanks for your interest in Mito Agent. We will reach out to{" "}
                <strong>{formData.email}</strong> shortly.
              </p>
              <Link to="/" className={styles.backLink}>
                Back to Home
              </Link>
            </motion.div>
          )}
        </motion.div>
      </div>
    </div>
  );
}
